import Loadable from '../../components/loadable';

const GoCardlessMandatesReport = Loadable({
  loader: () => import('../../pages/reports/gocardless_mandates_report/gocardless_mandates_report'),
});

angular.module('gym').value('GoCardlessMandatesReport', GoCardlessMandatesReport);

const GoCardlessMandatesReportFiltersModal = Loadable({
  loader: () =>
    import(
      '../../pages/reports/gocardless_mandates_report/gocardless_mandates_report_filters_modal'
    ),
  type: 'modal',
});

angular
  .module('gym')
  .value('GoCardlessMandatesReportFiltersModal', GoCardlessMandatesReportFiltersModal);
